module.exports = __webpack_public_path__ + "static/media/logo_PNG.5b2b564d.png";